/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BulkProgress} from '../models/BulkProgress';
import type {Error} from '../models/Error';
import type {UpdateAccountEntitlementsResult} from '../models/UpdateAccountEntitlementsResult';
import type {UpdateEntitlementsRelation} from '../models/UpdateEntitlementsRelation';

export interface BulkProductAssignAccountEntitlements$Request {
    updateEntitlementsRelation: UpdateEntitlementsRelation;
    reason?: string;
}

export interface BulkProductAssignAccountEntitlements$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const bulkProductAssignAccountEntitlementsRequest = createAction<PayloadData<void, BulkProductAssignAccountEntitlements$Request>>('BULK_PRODUCT_ASSIGN_ACCOUNT_ENTITLEMENTS__BULK_PRODUCT_ASSIGN_ACCOUNT_ENTITLEMENTS__REQUEST');
export const bulkProductAssignAccountEntitlementsSuccess = createAction<PayloadData<string, BulkProductAssignAccountEntitlements$Request>>('BULK_PRODUCT_ASSIGN_ACCOUNT_ENTITLEMENTS__BULK_PRODUCT_ASSIGN_ACCOUNT_ENTITLEMENTS__SUCCESS');
export const bulkProductAssignAccountEntitlementsFailure = createAction<PayloadData<Error, BulkProductAssignAccountEntitlements$Request, true>>('BULK_PRODUCT_ASSIGN_ACCOUNT_ENTITLEMENTS__BULK_PRODUCT_ASSIGN_ACCOUNT_ENTITLEMENTS__FAILURE');

export const bulkProductAssignAccountEntitlementsActions = [
    bulkProductAssignAccountEntitlementsRequest,
    bulkProductAssignAccountEntitlementsSuccess,
    bulkProductAssignAccountEntitlementsFailure
] as const;

/**
 * @param {UpdateEntitlementsRelation} meta.updateEntitlementsRelation
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const bulkProductAssignAccountEntitlements = (meta: BulkProductAssignAccountEntitlements$Request, config?: BulkProductAssignAccountEntitlements$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: bulkProductAssignAccountEntitlementsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/product/accounts/entitlements/assign`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.updateEntitlementsRelation,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetProductAssignAccountEntitlementsProgress$Request {
    id: string;
}

export interface GetProductAssignAccountEntitlementsProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getProductAssignAccountEntitlementsProgressRequest = createAction<PayloadData<void, GetProductAssignAccountEntitlementsProgress$Request>>('BULK_PRODUCT_ASSIGN_ACCOUNT_ENTITLEMENTS__GET_PRODUCT_ASSIGN_ACCOUNT_ENTITLEMENTS_PROGRESS__REQUEST');
export const getProductAssignAccountEntitlementsProgressSuccess = createAction<PayloadData<BulkProgress, GetProductAssignAccountEntitlementsProgress$Request>>('BULK_PRODUCT_ASSIGN_ACCOUNT_ENTITLEMENTS__GET_PRODUCT_ASSIGN_ACCOUNT_ENTITLEMENTS_PROGRESS__SUCCESS');
export const getProductAssignAccountEntitlementsProgressFailure = createAction<PayloadData<Error, GetProductAssignAccountEntitlementsProgress$Request, true>>('BULK_PRODUCT_ASSIGN_ACCOUNT_ENTITLEMENTS__GET_PRODUCT_ASSIGN_ACCOUNT_ENTITLEMENTS_PROGRESS__FAILURE');

export const getProductAssignAccountEntitlementsProgressActions = [
    getProductAssignAccountEntitlementsProgressRequest,
    getProductAssignAccountEntitlementsProgressSuccess,
    getProductAssignAccountEntitlementsProgressFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getProductAssignAccountEntitlementsProgress = (meta: GetProductAssignAccountEntitlementsProgress$Request, config?: GetProductAssignAccountEntitlementsProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getProductAssignAccountEntitlementsProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/product/accounts/entitlements/assign/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetProductAssignAccountEntitlementsResult$Request {
    id: string;
}

export interface GetProductAssignAccountEntitlementsResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getProductAssignAccountEntitlementsResultRequest = createAction<PayloadData<void, GetProductAssignAccountEntitlementsResult$Request>>('BULK_PRODUCT_ASSIGN_ACCOUNT_ENTITLEMENTS__GET_PRODUCT_ASSIGN_ACCOUNT_ENTITLEMENTS_RESULT__REQUEST');
export const getProductAssignAccountEntitlementsResultSuccess = createAction<PayloadData<UpdateAccountEntitlementsResult, GetProductAssignAccountEntitlementsResult$Request>>('BULK_PRODUCT_ASSIGN_ACCOUNT_ENTITLEMENTS__GET_PRODUCT_ASSIGN_ACCOUNT_ENTITLEMENTS_RESULT__SUCCESS');
export const getProductAssignAccountEntitlementsResultFailure = createAction<PayloadData<Error, GetProductAssignAccountEntitlementsResult$Request, true>>('BULK_PRODUCT_ASSIGN_ACCOUNT_ENTITLEMENTS__GET_PRODUCT_ASSIGN_ACCOUNT_ENTITLEMENTS_RESULT__FAILURE');

export const getProductAssignAccountEntitlementsResultActions = [
    getProductAssignAccountEntitlementsResultRequest,
    getProductAssignAccountEntitlementsResultSuccess,
    getProductAssignAccountEntitlementsResultFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getProductAssignAccountEntitlementsResult = (meta: GetProductAssignAccountEntitlementsResult$Request, config?: GetProductAssignAccountEntitlementsResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getProductAssignAccountEntitlementsResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/product/accounts/entitlements/assign`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

